import { Skeleton } from "@nextui-org/react";

import React from "react";

function CardSekelon() {
  return (
    <div className="flex flex-col items-start space-y-[12px] overflow-hidden w-full ">
      <div
        className="flex flex-row items-center justify-start space-x-2
      w-full no-scrollbar"
      >
        <Skeleton className="flex rounded-full w-[120px] h-[40px] !bg-[#7D7D7D] before:!duration-600 before:!bg-opacity-10" />
      </div>
      <div className="w-full">
        <Skeleton className=" w-full  aspect-square bg-[#7D7D7D] rounded-[28px] before:!duration-600 before:!bg-opacity-10" />
        <Skeleton className=" h-[28px] w-[90%] !bg-[#7D7D7D] rounded-full mt-[12px] before:!duration-600 before:!bg-opacity-10" />
        <Skeleton className=" h-[28px] w-[30%] !bg-[#7D7D7D] rounded-full mt-[6px] before:!duration-600 before:!bg-opacity-10" />
        <Skeleton className=" h-[16px] w-[40%] !bg-[#7D7D7D] rounded-full mt-[40px] before:!duration-600 before:!bg-opacity-10" />
      </div>
    </div>
  );
}

export default CardSekelon;
